export default __webpack_public_path__ + "static/media/accept-tasks.8aa8318b.svg";